import {
  Body2,
  Button,
  ButtonGroup,
  ButtonGroupSection,
  Display3,
  Modal,
} from '@sainsburys-tech/fable'
import React, { useEffect, useState } from 'react'

import { IModal } from '../../types/IModal'

const SaveModal = (props: IModal) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const closeModal = () => {
    setIsModalOpen(false)
    props.onClose()
  }

  useEffect(() => {
    setIsModalOpen(props.isOpen)
  }, [props.isOpen])

  return (
    <div className='c-common-modal' data-testid='saveModal'>
      <Modal onClose={() => closeModal()} isOpen={isModalOpen}>
        <Display3 data-testid='modalTitle' style={{ marginBottom: '16px' }}>
          {props.modalTitle}
        </Display3>
        {props.modalBody && (
          <Body2 data-testid='modalBody' style={{ marginBottom: '48px' }}>
            {props.modalBody}
          </Body2>
        )}
        <ButtonGroup>
          <ButtonGroupSection>
            <Button
              testid='on-yes-button'
              onClick={() => props.onYes !== undefined && props.onYes()}
              variant='tertiary'
            >
              {props.modalYes ? props.modalYes : 'Yes'}
            </Button>
            <Button
              testid='on-no-button'
              onClick={() => props.onNo !== undefined && props.onNo()}
              variant='tertiary'
            >
              {props.modalNo ? props.modalNo : 'No'}
            </Button>
          </ButtonGroupSection>
        </ButtonGroup>
      </Modal>
    </div>
  )
}

export default SaveModal
